import React from 'react';
import sunrise from '../assets/img/sunrise.png';
import sunset from '../assets/img/sunset.png';
import evening from '../assets/img/night.png';
let date = new Date();

 const GreetUser = () => {
   return(
     <div>
     <div>
     <h6 className="text-center">{date.getHours() < 12  ? 'Good Morning' : date.getHours() >= 12 && date.getHours() <=15 ? 'Good Afternoon' : 'Good Evening'}</h6>
     <h4 className="text-center text-capitalize">{`${localStorage.getItem("codefussion-student-first-name")} ${localStorage.getItem("codefussion-student-last-name")}` }</h4>
     </div>

     {/*<div>
     <img src={date.getHours() < 12 ? sunrise : date.getHours() >= 12 && date.getHours() <=15 ? sunset : evening } className="weather-img" />
     </div> */}
     </div>
   )
}

export default GreetUser;
